import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';

/**
 * @summary Type here the description of this component
 * @tag lp-widget-welcome
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('lp-widget-welcome')
export class LpMockWidgetsWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title fontSize="16">Welcome banner</gz-title>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium beatae et, ex ipsa magnam molestias natus
        nihil nostrum officiis quasi reprehenderit sapiente totam voluptas? Animi aperiam asperiores aut beatae cum
        deserunt et impedit inventore iure, molestiae natus nulla odit pariatur perspiciatis provident quaerat, quidem
        repellat repellendus sapiente similique sunt tempora!
      </p>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lp-widget-welcome': LpMockWidgetsWebComponent;
  }
}

@customElement('lp-widget-product-trials')
export class LpWidgetProductTrialsWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title fontSize="16">Product trials</gz-title>
      <p>
        Asperiores culpa dolorem enim eum fugit in, iste iure laboriosam nam quis repellat saepe ut vel? Doloribus error
        incidunt inventore labore laudantium maiores necessitatibus nobis nostrum officia, quaerat quod ratione rerum,
        tempora velit veniam vero voluptas!
      </p>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lp-widget-product-trials': LpWidgetProductTrialsWebComponent;
  }
}

@customElement('lp-widget-help-support')
export class LpWidgetHelpSupportWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title fontSize="16">Help & support</gz-title>
      <p>tempora velit veniam vero voluptas!</p>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lp-widget-help-support': LpWidgetHelpSupportWebComponent;
  }
}

@customElement('lp-widget-news')
export class LpWidgetNewsWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title fontSize="16">news</gz-title>
      <div style="display: flex; justify-content: space-between">
        <div class="box" style="width: 33%; height: 200px; background-color: #6c6c6c">1</div>
        <div class="box" style="width: 33%; height: 200px; background-color: #6c6c6c">2</div>
        <div class="box" style="width: 33%; height: 200px; background-color: #6c6c6c">3</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lp-widget-news': LpWidgetHelpSupportWebComponent;
  }
}

@customElement('lp-widget-cloud-security')
export class LpWidgetCloudSecurityWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title fontSize="20">Cloud security widget</gz-title>
      <gz-text fontSize="16" lineHeight="1"
        >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias aut corporis doloremque eius et eveniet modi
        nostrum odit quas quod!</gz-text
      >
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lp-widget-cloud-security': LpWidgetCloudSecurityWebComponent;
  }
}

@customElement('lp-widget-mobile-security')
export class LpWidgetMobileSecurityWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title fontSize="20">Mobile security widget</gz-title>
      <gz-text fontSize="16" lineHeight="1"
        >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias exercitationem minus mollitia repellendus ullam
        unde? Ab ad, culpa enim eum eveniet ipsam, molestias nobis nostrum praesentium, recusandae sequi tenetur
        vero.</gz-text
      >
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lp-widget-mobile-security': LpWidgetMobileSecurityWebComponent;
  }
}
